<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="抄表项">
              <j-multi-select-tag
                @change="searchQuery"
                dictCode="`iwt-wf`.iot_sensor_read_item,item_name,id"
                placeholder="请选择抄表项"
                v-model="queryParam.itemId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="8" :md="8" :sm="24" :xl="8">
            <a-form-item label="抄表时间">
              <a-range-picker
                :placeholder="['开始时间', '结束时间']"
                :show-time="true"
                @change="onDateChange"
                date-format="YYYY-MM-DD HH:mm:ss"
              ></a-range-picker>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('抄表记录')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <iot-sensor-read-records-modal @ok="modalFormOk" ref="modalForm"></iot-sensor-read-records-modal>
    <iot-sensor-read-add-modal @ok="modalFormOk" ref="addModalForm"></iot-sensor-read-add-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import IotSensorReadRecordsModal from './modules/IotSensorReadRecordsModal'
  import IotSensorReadAddModal from './modules/IotSensorReadAddModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'IotSensorReadRecordsList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      IotSensorReadRecordsModal,
      IotSensorReadAddModal
    },
    data () {
      return {
        description: '抄表记录管理页面',
        description: '日常检修任务管理页面',
        // 查询条件
        queryParam: {
          itemId: '',
          dataTime: [],
        },
        isorter: {
          column: 'dataTime',
          order: 'desc',
        },
        // 表头
        columns: [
          {
            title: '抄表时间',
            align: "center",
            dataIndex: 'dataTime',
            sorter: true,
          },
          {
            title: '抄表项',
            align: "center",
            dataIndex: 'itemId_dictText',
            sorter: true,
          },
          {
            title: '负责人',
            align: "center",
            dataIndex: 'responsibleId_dictText',
            sorter: true,
          },
          // 
          {
            title: '值',
            align: "right",
            dataIndex: 'value',
            sorter: true,
          },
          {
            title: '单位',
            align: "center",
            dataIndex: 'dataUnit'
          },

          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/read/records/list",
          delete: "/read/records/delete",
          deleteBatch: "/read/records/deleteBatch",
          exportXlsUrl: "/read/records/exportXls",
          importExcelUrl: "read/records/importExcel",

        },
        dictOptions: {},
        superFieldList: [],
      }
    },
    created () {
      this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      handleAdd: function () {
        this.$refs.addModalForm.add()
        this.$refs.addModalForm.title = '新增'
        this.$refs.addModalForm.disableSubmit = false
      },
      onDateChange: function (value, dateString) {
        this.queryParam.dataTime_begin = dateString[0];
        this.queryParam.dataTime_end = dateString[1];
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'itemId', text: '抄表项', dictCode: '`iwt-wf`.iot_sensor_read_item,item_name,id' })
        fieldList.push({ type: 'datetime', value: 'dataTime', text: '抄表时间' })
        fieldList.push({ type: 'string', value: 'value', text: '值', dictCode: '' })
        fieldList.push({ type: 'string', value: 'dataUnit', text: '单位', dictCode: '' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>